// extracted by mini-css-extract-plugin
export var container = "_e8-0";
export var content = "_e8-3";
export var customerTitle = "_e8-4";
export var empty = "_e8-5";
export var gray = "_e8-6";
export var header = "_e8-7";
export var info = "_e8-8";
export var loading = "_e8-2";
export var loadingCard = "_e8-9";
export var oneLine = "_e8-a";
export var personName = "_e8-e";
export var pillContainer = "_e8-b";
export var selected = "_e8-1";
export var text = "_e8-c";
export var twoLines = "_e8-d";
export var unread = "_e8-f";
export var unreadIndicator = "_e8-g";